import { FormattedMessage, useIntl } from 'react-intl';

import styles from './ApplicantCallAction.module.css';
import { PhoneNumberButton } from '../../../ui/supportWidget/supportActionList/callSupportButtonWithModal/callSupportModal/phoneNumberButton';

const ApplicantCallModal = ({
    isIwocaPay
}: {
    onClose: () => void;
    isIwocaPay: boolean;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.ApplicantCallModal}>
            <h2 className={styles.title}>
                {isIwocaPay ? (
                    <FormattedMessage
                        id="_.iwocapay.draw_down.step_buttons.action_applicant_call_modal_title"
                        defaultMessage="Give us a quick call"
                    />
                ) : (
                    <FormattedMessage
                        id="_.funding_requirements.action_applicant_call_modal_title"
                        defaultMessage="Give us a quick call"
                    />
                )}
            </h2>
            <div className={styles.callSubText}>
                {isIwocaPay ? (
                    <FormattedMessage
                        id="_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.call_sub_text"
                        defaultMessage="You're nearly there. Based on your application so far, you'll need to call your account manager to finish the last step."
                    />
                ) : (
                    <FormattedMessage
                        id="_.funding_requirements.action_applicant_call_modal.call_sub_text"
                        defaultMessage="You're nearly there. Based on your application so far, you'll need to call your account manager to finish the last step."
                    />
                )}
            </div>
            <div className={styles.number}>
                <PhoneNumberButton
                    displayPhoneNumber={
                        isIwocaPay ? (
                            <FormattedMessage
                                id="_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.displayPhoneNumber"
                                defaultMessage="020 3778 0549"
                            />
                        ) : (
                            <FormattedMessage
                                id="_.funding_requirements.action_applicant_call_modal.displayPhoneNumber"
                                defaultMessage="020 3778 0105"
                            />
                        )
                    }
                    callPhoneNumber={
                        isIwocaPay
                            ? intl.formatMessage({
                                  id: '_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.callPhoneNumber',
                                  defaultMessage: '+44-0203-778-0549'
                              })
                            : intl.formatMessage({
                                  id: '_.funding_requirements.action_applicant_call_modal.callPhoneNumber',
                                  defaultMessage: '+44-020-3778-0105'
                              })
                    }
                />
            </div>

            <div
                className={styles.availability}
                data-testid="availability-info"
            >
                <div className={styles.availabilityMonFri}>
                    {isIwocaPay ? (
                        <FormattedMessage
                            id="_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.availability_message_line_one"
                            defaultMessage="Mon - Fri"
                            tagName="strong"
                        />
                    ) : (
                        <FormattedMessage
                            id="_.funding_requirements.action_applicant_call_modal.availability_message_line_one"
                            defaultMessage="Monday to Friday (excluding bank holidays)"
                            tagName="strong"
                        />
                    )}
                    <div className={styles.openingTimes}>
                        {isIwocaPay ? (
                            <FormattedMessage
                                id="_.iwocapay.draw_down.step_buttons.action_applicant_call_modal.times_for_message_line_one"
                                defaultMessage="8am - 7pm"
                            />
                        ) : (
                            <FormattedMessage
                                id="_.funding_requirements.action_applicant_call_modal.times_for_message_line_one"
                                defaultMessage="9am - 6pm"
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default ApplicantCallModal;
